import colors from '@nykaa/ui-components/tokens/colors';
import { hexToRgb } from '@nykaa/ui-components/styles/utils';

export const theme = {
  colors: {
    primary: '#000000',
    primary10: '#757575',
    primary20: colors.pebble200,
    primary30: colors.pebble400,
    primary40: colors.pebble600,
    primary50: colors.pebble700,

    surface: colors.snow100,
    surface10: colors.snow200,
    surface20: colors.snow300,
    surface30: colors.snow500,
    surface40: colors.snow600,
    surface50: colors.snow900,

    secondary: '#000000',
    secondary10: '#F9FAFA',
    secondary20: colors.salmon100,
    secondary30: colors.salmon400,
    secondary40: colors.salmon600,
    secondary50: colors.salmon700,

    inverse: colors.black100,
    inverse10: colors.black700,
    inverse20: colors.black600,
    inverse30: colors.black500,
    inverse40: colors.black400,
    inverse50: colors.black300,

    info: colors.blue600,
    // Note: value of blue50 is "#e6f2ff" rather than #E7F2FF
    info10: '#E5EE57',

    pdpTagColor: colors.blue600,

    stateHover: hexToRgb(colors.snow600, 0.08),
    statePressed: hexToRgb(colors.snow600, 0.16),
    stateDisabled: hexToRgb(colors.snow600, 0.36),

    textPrimary: '#000000',
    textSecondary: hexToRgb('#000000', 0.64),
    textOutline: hexToRgb('#000000', 0.16),
    textDecorative: hexToRgb('#000000', 0.08),
    textDisabled: '#6D7780',
    textInversePrimary: colors.snow100,

    surfaceInverse: colors.black100,
    surfaceInverse10: colors.black600,
    surfaceInverse20: colors.black500,
    surfaceInverse30: colors.black400,
    surfaceInverse40: colors.black300,
    surfaceInverse50: colors.black200,

    state: colors.snow600,
    menuItemHover: colors.snow100,
    viewBagColor: '#FFFFFF',
    hnmTabActiveColor: '#E50010',
    hnmTabInactiveColor: '#596875',

    positivePrimary: colors.green700,
    negativePrimary: colors.red700,
    negative10: colors.red50,
    negativeOpacity8: hexToRgb(colors.red700, 0.08),
    negativeOpacity16: hexToRgb(colors.red700, 0.16),

    warningPrimary: colors.orange700,
    warning10: colors.orange50,
    warningOpacity8: hexToRgb(colors.orange600, 0.08),
    warningOpacity16: hexToRgb(colors.orange600, 0.16),

    filterSurface: colors.snow100,
    filterHover: colors.snow200,
    filterSelected: colors.snow200,
    filterBackdropFilter: '0',
    reviewTagBackground: colors.snow200,
    searchTextColor: hexToRgb('#000000', 0.36),
    searchBgColor: '#ebecf0',
    mwebSearchWidgetBgColor: colors.snow300,
    dwebSearchBgColor: colors.snow100,
    searchSectionBgColor: colors.snow300,
    searchTermBorderColor: '#dfe1e6',
    suggestionIconColor: hexToRgb('#000000', 0.4),
    overlayBg: colors.snow100,
    brandbookTagBg: colors.snow300,
    brandbookBrandTagBg: '#000000',
    brandbookBrandTagTextColor: colors.snow100,
    wishlistIconBg: colors.snow100,
    mwebFilterBg: colors.snow200,
    mwebFilterSelected: colors.snow100,
    sizeSelected: '#000000',
    ratingBg: colors.snow200,
    subtextColor: '#000000',
    sizeGuideColor1: colors.snow300,
    sizeGuideBorder: 'transparent',
    sizeGuidePillBg: 'transparent',
    sizeGuideToggleBg: '#F9FAFA',
    sizeGuideToggleOutline: '#000000',
    pdpCouponsSectionBg: colors.snow100,
    pdpCouponBgImgOpacity: 1,
    pdpCavSectionBg: colors.snow300,
    filterInputBg: colors.snow300,
    eddInputBg: colors.snow300,
    eddInputFocus: colors.snow300,
    responsibleTagBg: 'rgba(0, 137, 69, 0.12)',
    shimmerBg: colors.snow300,
    wishlistNudge: colors.black300,
  },
  borders: {
    buttonBorderRadius: '2px',
    mwebButtonBorderRadius: '2px',
  },
  typography: {},
};
